// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { EmployeeGroupPermission, PermissionState } from '@fc-core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  constructor(private http: HttpClient) {}

  getGroupPermissions(groupId: number): Observable<EmployeeGroupPermission[]> {
    return this.http.get<EmployeeGroupPermission[]>(
      `${environment.apiUrl}api/employee-groups/${groupId}/permissions/`,
    );
  }

  addGroupPermissions(
    groupId: number,
    permissions: number,
  ): Observable<{ permissionsTemplate: number[] }> {
    return this.http.post<{ permissionsTemplate: number[] }>(
      `${environment.apiUrl}api/employee-groups/${groupId}/permissions/add/`,
      { permissionsTemplate: [permissions] },
    );
  }

  removeGroupPermissions(
    groupId: number,
    permissions: number,
  ): Observable<{ permissionsTemplate: number[] }> {
    return this.http.post<{ permissionsTemplate: number[] }>(
      `${environment.apiUrl}api/employee-groups/${groupId}/permissions/remove/`,
      { permissionsTemplate: [permissions] },
    );
  }

  get userPermissions(): PermissionState[] {
    const permissionsString = localStorage.getItem('permissions');
    if (permissionsString) {
      const perms: PermissionState[] = JSON.parse(permissionsString);
      return perms.filter(
        (perm, index, self) =>
          self.findIndex((p) => p.fullCodename === perm.fullCodename) === index,
      );
    }
    return [];
  }

  get havePermissions(): boolean {
    return !!(this.userPermissions && this.userPermissions.length);
  }

  haveActivePermission(permissionName: string): boolean {
    if (!this.userPermissions || !this.userPermissions.length) return;
    const havePermission = this.userPermissions.filter(
      (i) => i.fullCodename === permissionName,
    )[0];
    return havePermission && havePermission.active;
  }

  setPermissions(permissions: PermissionState[]): void {
    const localPermissions: PermissionState[] =
      JSON.parse(localStorage.getItem('permissions')) || [];

    const uniqueBackend = permissions.filter(
      (perm, index, self) =>
        self.findIndex((p) => p.fullCodename === perm.fullCodename) === index,
    );

    const currentPermissions = uniqueBackend.map((permission) => {
      const local = localPermissions.find(
        (i) => i.fullCodename === permission.fullCodename,
      );
      return local ? { ...permission, active: local.active } : permission;
    });

    const backendCodenames = new Set(uniqueBackend.map((p) => p.fullCodename));
    const localOnly = localPermissions.filter(
      (p) => !backendCodenames.has(p.fullCodename),
    );

    const merged = [...currentPermissions, ...localOnly];
    const uniqueMerged = merged.filter(
      (perm, index, self) =>
        self.findIndex((p) => p.fullCodename === perm.fullCodename) === index,
    );

    localStorage.setItem('permissions', JSON.stringify(uniqueMerged));
  }

  updatePermissions(permissions: PermissionState[]) {
    const unique = permissions.filter(
      (perm, index, self) =>
        self.findIndex((p) => p.fullCodename === perm.fullCodename) === index,
    );
    localStorage.setItem('permissions', JSON.stringify(unique));
  }
}
